import { useEffect } from "react";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../services/firebase";

export default function useGPSListener(user) {
  useEffect(() => {
    if (!user) return;

    const watchId = navigator.geolocation.watchPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        const update = { lat: latitude, lng: longitude, timestamp: Date.now() };
        if (navigator.onLine) {
          setDoc(doc(db, "locations", user.uid), update);
        } else {
          localStorage.setItem("lastLocationUpdate", JSON.stringify(update));
        }
      },
      (err) => console.error("GPS error:", err),
      { enableHighAccuracy: true, maximumAge: 10000, timeout: 5000 }
    );

    const syncOffline = () => {
      const saved = localStorage.getItem("lastLocationUpdate");
      if (saved) {
        setDoc(doc(db, "locations", user.uid), JSON.parse(saved));
        localStorage.removeItem("lastLocationUpdate");
      }
    };

    window.addEventListener("online", syncOffline);
    return () => {
      navigator.geolocation.clearWatch(watchId);
      window.removeEventListener("online", syncOffline);
    };
  }, [user]);
}
